import React, { memo } from 'react';
import classNames from 'classnames/bind';
import style from "./styles.pcss";
var cn = classNames.bind(style);
export var Label = /*#__PURE__*/memo(function (_ref) {
  var id = _ref.id,
    children = _ref.children,
    className = _ref.className,
    _ref$testName = _ref.testName,
    testName = _ref$testName === void 0 ? 'Label' : _ref$testName,
    disabled = _ref.disabled,
    label = _ref.label;
  return /*#__PURE__*/React.createElement("label", {
    className: cn('label', className, {
      'label--disabled': disabled
    }),
    "data-component": testName,
    htmlFor: id || undefined,
    "data-t-id": "src-Label"
  }, /*#__PURE__*/React.createElement("span", {
    className: cn({
      label__text: children
    })
  }, label), children && children);
});
Label.displayName = Label.name;